import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import { StudentAssignmentUpsertRequest } from '../../../../../../../api/types/assignment-student-details/request/upsert/request-upsert-assignment-details';
import { AssignmentDetailsUpsert } from '../../../../../../../api/types/assignment-student-details/request/upsert/request-assignment-details';
import globalCourseStore from '../../../../../../../stores/global-course-store';
import dateUtils from '../../../../../../../utils/date-format';

export const upsertStudentsAssignmentData = async (
  programId: number | undefined,
  courseId: number | undefined,
  assignmentId: number,
  studentAssignment: Map<
    number,
    {
      studentAssignmentId?: number;
      grade?: number;
      dueDate?: Date;
    }
  >,
) => {
  try {
    // TODO validate programId and courseId
    if (isNaN(Number(programId)) || isNaN(Number(courseId))) {
      console.error(
        `Can not find curretn programId: ${programId} and courseId: ${courseId}`,
      );
      toast.warn(
        'לא ניתן לאתר את מזהה התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים',
      );
      return;
    }

    const upsertRequests: StudentAssignmentUpsertRequest[] = [];

    studentAssignment.forEach((details, studentId) => {
      const assignmentDetails: AssignmentDetailsUpsert = {
        studentAssignmentId: details.studentAssignmentId,
        grade: details.grade,
        dueDate: details.dueDate
          ? dateUtils.formattedDateWithNoTime(details.dueDate)
          : details.dueDate,
      };

      upsertRequests.push({
        studentId: studentId,
        assignmentDetails: assignmentDetails,
      });
    });

    await appApi.upsertStudentsAssignmentData(
      programId!,
      courseId!,
      assignmentId,
      upsertRequests,
    );
    await globalCourseStore.fetchCourseDetails(programId!, courseId!);
    toast.success('הפעולה התבצעה בהצלחה');
  } catch (e) {
    toast.error('לא ניתן לבצע את הפעולה המבוקשת. נשסה שוב בעוד מספר רגעים...');
  }
};
